import * as Yup from 'yup'
import { emailSchema } from './email.validation'
import { EAccountRoles } from 'src/types'

const roles = Object.values(EAccountRoles)

const inviteAccountUserSchema = Yup.object().shape({
  email: emailSchema.required('validation-required'),
  role: Yup.string().oneOf(roles).required('validation-required'),
})

export { inviteAccountUserSchema }
